import { styled as styledMUI } from '@mui/material/styles';

// eslint-disable-next-line import/prefer-default-export
export const StyledGate = styledMUI('div')`
    width: 1;
    position: relative;
    border: 1px dashed black;
    margin: 30px 0px 0px 0px;
`;
